var map = {
	"./bill/router/index.js": 374,
	"./feedback/router/index.js": 375,
	"./hotel/router/index.js": 376,
	"./lottery/router/index.js": 377
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 754;


//////////////////
// WEBPACK FOOTER
// ./src/addon index\.js$
// module id = 754
// module chunks = 15